/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  aws_project_region: "sa-east-1",
  aws_cognito_region: "sa-east-1",
  aws_user_pools_id: "sa-east-1_RI0PFl6xt",
  aws_user_pools_web_client_id: "1o5e85dghdsdhojpubeh2v8425",
  oauth: {},
  aws_cognito_login_mechanism: ["EMAIL"],
  aws_cognito_signup_attributes: ["EMAIL", "PHONE_NUMBER"],
  aws_cognito_mfa_configuration: "ON",
  aws_cognito_mfa_types: ["SMS"],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [
      "REQUIRES_LOWERCASE",
      "REQUIRES_UPPERCASE",
      "REQUIRES_NUMBERS",
      "REQUIRES_SYMBOLS",
    ],
  },
};

export default awsmobile;
